import React, { useRef, useEffect } from 'react';
import {
  Header,
  WhereToBuy,
  Contact,
  Footer,
  BannerFooter,
  FollowUs,
  Hero,
  Products,
  AboutUs,
  Recipes,
  RecipesAllSection,
} from '../components';
import StoreModal from '../components/StoreModal/StoreModal';
import { favicon } from '../assets/images';
import { Helmet } from 'react-helmet';

const Home = () => {
  const contactRef = useRef(null);
  const WTBRef = useRef(null);
  const recipesRef = useRef(null);
  const aboutUsRef = useRef(null);
  const productsRef = useRef(null);
  const imageWhereToBuy = useRef(null);

  useEffect(() => {
    if (window.location.hash === '#where-to-buy') {
      setTimeout(() => {
        window.scrollTo({
          top: WTBRef.current.getBoundingClientRect().top + window.scrollY,
          behavior: 'smooth',
        });
      }, 1000);
    }
  }, []);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Isadora Mexican Food | Ready-to-Eat Mexican Beans and Rice</title>
        <link rel="canonical" href="https://www.isadoramexicanfood.com/" />
        
        <meta name="description"
        content="Discover Isadora Mexican Food, including ready-to-eat beans and Mexican rice pouches inspired by authentic flavors from Mexico." 
        />
        <meta
          name="keywords"
          content="beans, mexico, isadora beans, food, fresh food, tasty, mexican food"
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta
          property="og:title"
          content="Mexican Foods | Isadora Beans | Mexico is just 2 minutes away"
        />
        <meta property="og:url" content="https://www.isadoramexicanfood.com/" />
        <meta property="og:image" content={favicon} />
        <link rel="icon" href={favicon} />
        <script type="application/ld+json">
          {JSON.stringify({
                "@context": "https://schema.org",
                "@graph": [
                    {
                    "@type": "Organization",
                    "@id": "https://www.isadoramexicanfood.com/#organization",
                    "name": "Isadora Mexican Food",
                    "url": "https://www.isadoramexicanfood.com/",
                    "logo": {
                        "@type": "ImageObject",
                        "url": "https://www.isadoramexicanfood.com/path-to-logo.png"
                    },
                    "sameAs": [
                        "https://www.instagram.com/isadoramexicanfood/",
                        "https://www.facebook.com/IsadoraMexicanFood/"
                    ]
                    },
                    {
                    "@type": "WebSite",
                    "@id": "https://www.isadoramexicanfood.com/#website",
                    "url": "https://www.isadoramexicanfood.com/",
                    "name": "Isadora Mexican Food",
                    "publisher": {
                        "@id": "https://www.isadoramexicanfood.com/#organization"
                    },
                    "inLanguage": "en-US"
                    },
                    {
                    "@type": "WebPage",
                    "@id": "https://www.isadoramexicanfood.com/#webpage",
                    "url": "https://www.isadoramexicanfood.com/",
                    "name": "Isadora Mexican Food | Ready-to-Eat Mexican Beans and Rice",
                    "isPartOf": {
                        "@id": "https://www.isadoramexicanfood.com/#website"
                    },
                    "about": {
                        "@id": "https://www.isadoramexicanfood.com/#organization"
                    },
                    "inLanguage": "en-US"
                    }
                ]
            })}
      </script>
      </Helmet>
      <Header
        contactRef={contactRef}
        WTBRef={WTBRef}
        recipesRef={recipesRef}
        aboutUsRef={aboutUsRef}
        productsRef={productsRef}
      />
      <h1 className="sr-only">Authentic Ready-to-Eat Mexican Food</h1>
      <Hero />
      <AboutUs ref={aboutUsRef} />
      <Products ref={productsRef} />
      <Recipes ref={recipesRef} />
      <RecipesAllSection />
      <WhereToBuy ref={WTBRef} imageRef={imageWhereToBuy} />
      <Contact ref={contactRef} />
      <FollowUs />
      <BannerFooter />
      <Footer
        contactRef={contactRef}
        WTBRef={WTBRef}
        recipesRef={recipesRef}
        aboutUsRef={aboutUsRef}
        productsRef={productsRef}
      />
      <StoreModal />
    </div>
  );
};

export default Home;
